import { render, staticRenderFns } from "./huoDongList.vue?vue&type=template&id=12b4b455&scoped=true&"
import script from "./huoDongList.vue?vue&type=script&lang=js&"
export * from "./huoDongList.vue?vue&type=script&lang=js&"
import style0 from "./huoDongList.vue?vue&type=style&index=0&id=12b4b455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4b455",
  null
  
)

export default component.exports